import { useCallback } from "react"
import { appConstants } from "../appConstants"
import { Team } from "../dto/team"
import { Collaborator } from "../dto/user/collaborator"
import { ProjectUser } from "../dto/v0-bm-project/project-user"
import { resolveUrl } from "../services/http-service"
import { useHttp } from "./use-http"

export function useTeams(): ProjectsHook {
  const { get, deleteRequest, post } = useHttp()

  /**
   * @deprecated
   */
  const fetchTeamV0: (projectId: string) => Promise<Team> = useCallback(
    (projectId) =>
      get(`${appConstants.apiEndpoints.V0_BM_PROJECTS}/team`, [
        {
          key: "projectId",
          value: projectId,
        },
      ]).then((response) => response.json()),
    [get]
  )

  const fetchContact: () => Promise<ProjectUser[]> = useCallback(
    () => get(`${appConstants.apiEndpoints.USER}/by-organization`).then((response) => response.json()),
    [get]
  )

  const fetchTeam: (projectId: string) => Promise<Collaborator[]> = useCallback(
    (projectId) =>
      get(appConstants.apiEndpoints.TEAM, [{ key: "projectId", value: projectId }]).then((response) => response.json()),
    [get]
  )

  const postTeamMember: (cognitoUserId: string, projectId: string) => Promise<Collaborator> = useCallback(
    (cognitoUserId, projectId) =>
      post(appConstants.apiEndpoints.TEAM, undefined, [
        { key: "projectId", value: projectId },
        { key: "cognitoUserId", value: cognitoUserId },
      ]).then((response) => response.json()),
    [post]
  )

  const revokeUserFromProject: (cognitoUserId: string, projectId: string) => Promise<any> = useCallback(
    (cognitoUserId, projectId) =>
      deleteRequest(appConstants.apiEndpoints.TEAM, [
        { key: "projectId", value: projectId },
        { key: "cognitoUserId", value: cognitoUserId },
      ]),
    [deleteRequest]
  )

  /**
   * @deprecated
   */
  const hasRseeProject: (projectId: string) => Promise<boolean> = useCallback(
    (projectId) =>
      get(resolveUrl(appConstants.apiEndpoints.RSEE_TEAM_ROLE, [projectId]), [])
        .then((response) => response.text())
        .then((data) => data === "true"),
    [get]
  )

  const countTeamNumber: (projectId: string) => Promise<number> = useCallback(
    (projectId) =>
      get(appConstants.apiEndpoints.TEAM_COUNT, [{ key: "projectId", value: projectId }]).then((response) =>
        response.json()
      ),
    [get]
  )

  return {
    fetchTeamV0,
    fetchContact,
    fetchTeam,
    postTeamMember,
    revokeUserFromProject,
    hasRseeProject,
    countTeamNumber,
  }
}

interface ProjectsHook {
  /**
   * @deprecated
   */
  fetchTeamV0(projectId: string): Promise<Team>
  fetchContact(): Promise<ProjectUser[]>
  fetchTeam(projectId: string): Promise<Collaborator[]>
  postTeamMember(cognitoUserId: string, projectId: string): Promise<Collaborator>
  revokeUserFromProject(cognitoUserId: string, projectId: string): Promise<void>
  /**
   * @deprecated
   */
  hasRseeProject(projectId: string): Promise<boolean>
  countTeamNumber(projectId: string): Promise<number>
}
